'use client'

import { useEffect } from 'react'
import sessionManager from '@/lib/sessionManager'

export default function SessionProvider({ children }) {
  useEffect(() => {
    // Initialize session manager on mount
    sessionManager.init()

    // Cleanup on unmount
    return () => {
      sessionManager.destroy()
    }
  }, [])

  return <>{children}</>
}
